import { curry, pathSatisfies, test, identity, path } from "ramda";

const propFilter = curry((pathList, regex) => pathSatisfies(test(regex), pathList));

/**
 * break down all data retrieved in index.js
 */
export default function breakDownAllNodes(nodes) {
  const filterByFileName = propFilter(["fields", "fileName"]);
  const filterByDirectoryName = propFilter(["fields", "directoryName"]);

  // top part
  const topNode = nodes.find(filterByFileName(/top/i)) || {};
  // navbar
  const navBarNode = nodes.find(filterByFileName(/navbar/i)) || {};
  // footer
  const footerNode = nodes.find(filterByFileName(/footer/i)) || {};

  // sections part
  // NOTE: `\~` was `~` escaped unnecessarily — provably identical in a JS regex
  // (verified against the same inputs), so this is behaviour-preserving.
  //
  // The regex itself is odd and is left alone deliberately: a bare negative
  // lookahead matches at almost any position, so this filter keeps nearly
  // everything rather than excluding a "~sections" directory as the name
  // suggests. Changing that would change which sections render, which is a
  // content decision and not a lint fix.
  const sectionsNodes = nodes.filter(filterByDirectoryName(/(?!(~)sections)/i));

  // anchors for NavBar
  const anchors = sectionsNodes.map(path(["frontmatter", "anchor"])).filter(identity);

  return {
    topNode,
    navBarNode,
    footerNode,
    sectionsNodes,
    anchors,
  };
}
